import { CarouselImage } from './CarouselImage'

export const DoubleColumnCarouselItem = ({
  firstColumn,
  secondColumn,
  imageWidth,
  imageHeight,
}: {
  firstColumn: string
  secondColumn: string
  imageWidth: number
  imageHeight: number
}) => (
  <div className='d-flex justify-content-center mc-gap-5 mc-mb-3'>
    <div>
      <CarouselImage
        className='mc-corners--md'
        key={firstColumn}
        src={firstColumn}
        width={imageWidth}
        height={imageHeight}
      />
    </div>
    <div
      style={{
        transform: 'translateY(-50%)', // Creates the running bond brick/staggered layout effect
      }}
    >
      <CarouselImage
        className='mc-corners--md'
        key={secondColumn}
        src={secondColumn}
        width={imageWidth}
        height={imageHeight}
      />
    </div>
  </div>
)
